export interface EmployeeGroupAssignInfo {
  empIds?: any[];
  id?: number;
  orgId?: string;
  subAccntNumbers?: any;
  employeeAccounts?: any[];
  newSelectedRecords?: any;
  removedExistingSelected?: any;
  assignEmpIds?: any[];
  assignSubAcctNumbers?: any[];
  unAssignEmpIds?: any[];
  unAssignSubAcctNumbers?: any[];
  subAccntNewlySelected?: any[];
  removedExistingEmpId?: any[];
  clear();
}

export const empGrpAssignInfo: EmployeeGroupAssignInfo = {
  empIds: [],
  id: 0,
  orgId: '',
  subAccntNumbers: [],
  employeeAccounts: [],
  newSelectedRecords: [],
  removedExistingSelected: [],
  assignEmpIds: [],
  assignSubAcctNumbers: [],
  unAssignEmpIds: [],
  unAssignSubAcctNumbers: [],
  subAccntNewlySelected: [],
  removedExistingEmpId: [],
  clear() {
    this.empIds = [];
    this.id = '';
    this.orgId = '';
    this.selectedEmpCount = {};
    this.subAccntNumbers = [];
    this.employeeAccounts = [];
    this.newSelectedRecords = [];
    this.removedExistingSelected = [];
    this.assignEmpIds = [];
    this.assignSubAcctNumbers = [];
    this.unAssignEmpIds = [];
    this.unAssignSubAcctNumbers = [];
    this.subAccntNewlySelected =  [];
    this.removedExistingEmpId = [];
  }
};

export interface EmpGroupFormDataModel {
  name?: string;
  orgId?: string;
  description?: string;
  id?: any;
  type?: string;
  mode?: string;
  planId?: string;
  currentEditedName?: string;
  currentEditedDescription?: string;
  selectedEmpCount?: any;
  ngOmsGroupInfo?: any;
  ruleIds?: any;
  subType?: string;
  toEnableOpenBrokeragePlan?: boolean;

  employeeGroupAssignInfo?: EmployeeGroupAssignInfo;

  clear();

  setData(data);
}

export const empGroupFormDataModel: EmpGroupFormDataModel = {
  name: '',
  orgId: '',
  description: '',
  id: '',
  type: 'EGP',
  mode: '',
  planId: '',
  selectedEmpCount: '',
  employeeGroupAssignInfo: empGrpAssignInfo,
  subType: '',
  toEnableOpenBrokeragePlan: false,

  clear() {
    this.name = '';
    this.currentEditedName = '';
    this.currentEditedDescription = '';
    this.description = '';
    this.id = '';
    this.orgId = '';
    this.mode = '';
    this.planId = '';
    this.selectedEmpCount = '';
    this.type = 'EGP';
    this.employeeGroupAssignInfo = empGrpAssignInfo;
    this.employeeGroupAssignInfo.clear();
    this.subType = '';
    this.toEnableOpenBrokeragePlan = false;
  },

  setData(data) {
    this.name = data.name || '';
    this.currentEditedName = data.currentEditedName !== undefined ? data.currentEditedName : (this.currentEditedName || data.name || '');
    this.currentEditedDescription = data.currentEditedDescription !== undefined ? data.currentEditedDescription : (this.currentEditedDescription || data.description || '');
    this.description = data.description || '';
    this.employeeGroupAssignInfo = data.employeeGroupAssignInfo || {};
    this.id = data.id || '';
    this.orgId = data.orgId || '';
    this.planId = data.planId || '';
    this.selectedEmpCount = data.selectedEmpCount || '';
    this.ngOmsGroupInfo = data.ngOmsGroupInfo || null;
    this.ruleIds = data.ruleIds || [];
    this.subType = data.subType || '';
  }
};

export class EmpGrpStep1 {
  name = '';
  groupDesc = '';
}

export class EmpGrpStep2 {
  employeeAccounts: any[] = [];
  newSelectedRecords: any = [];
  removedExistingSelected: any = [];
  assignEmpIds: any = [];
  assignSubAcctNumbers: any = [];
  unAssignEmpIds: any = [];
  unAssignSubAcctNumbers: any = [];
  empIds: any[] = [];
  subAccntNumbers: any[] = [];
  subAccntNewlySelected: any = [];
  removedExistingEmpId: any = [];
}
